// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GothamBold";
  src: url("/fonts/gothambold_normal_normal.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
@font-face {
  font-family: "GothamNarrowBook";
  src: url("/fonts/GothamNarrowBook_normal_condensed.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
.cvx-font-gotham-bold, aside .cvx-aside-left-title, aside .cvx-tree-empty {
  font-family: "GothamBold", Arial, sans-serif;
}

.cvx-fon-narrow-bold {
  font-family: "GothamNarrowBold", Arial, sans-serif;
}

.cvx-font-gotham-narrow-book {
  font-family: "GothamNarrowBook", Arial, sans-serif;
}

.cvx-gothan-medium {
  font-family: "GothamMedium", Arial, sans-serif;
}

/*font-szes*/
.extraLarge {
  font-size: 1.75rem;
  /*28px*/
}

.large2 {
  font-size: 1.375rem;
  /*22px*/
}

.large {
  font-size: 1.125rem;
  /*18px*/
}

.normal {
  font-size: 1rem;
  /*16px*/
}

.medium {
  font-size: 0.875rem;
  /*14px*/
}

.small {
  font-size: 0.75rem;
  /*12px*/
}

aside {
  display: grid;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  grid-template-columns: 100%;
  grid-template-rows: 40px 1fr;
  grid-template-areas: "aside-left-title" "aside-left-content";
  align-items: center;
  justify-items: center;
}
aside .cvx-aside-left-title {
  grid-area: aside-left-title;
  font-size: 20px;
  color: #0b2d71;
}
aside .cvx-aside-left-content {
  display: flex;
  flex-direction: column;
  grid-area: aside-left-content;
  overflow: auto;
  width: 100%;
  height: 100%;
}
aside .cvx-aside-left-controls {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
  padding: 8px;
}
aside .cvx-grouping-selector {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0;
}
aside .cvx-grouping-options {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}
aside .cvx-grouping-options label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
aside .cvx-aside-left-controls select {
  flex: 1;
}
aside .cvx-tree {
  width: 100%;
  flex: 1;
  overflow: auto;
  font-size: 14px;
  padding: 0 10px;
}
aside .cvx-tree-empty {
  color: #0b2d71;
  text-align: center;
  padding: 8px;
}
aside .spinner {
  display: flex;
  justify-content: center;
  width: 100%;
}

::ng-deep app-root {
  transition: 700ms;
}
::ng-deep app-root:has(* .cvx-no-transition) {
  transition: none !important;
}
::ng-deep app-root:has(app-cvx-aside-left aside.cvx-slide-panel.cvx-hidden-content) {
  grid-template-columns: 0px 1fr;
}
::ng-deep app-root:has(app-cvx-aside-left aside.cvx-slide-panel) {
  --left: 330px;
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.scss","webpack://./src/app/shared/components/cvx-aside-left/cvx-aside-left.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAQA;EACE,yBAAA;EACA,iEAAA;EACA,iBAPO;EAQP,gBARO;ACCT;ADUA;EACE,+BAAA;EACA,0EAAA;EACA,iBAdO;EAeP,gBAfO;ACOT;ADWA;EACE,4CAAA;ACTF;;ADYA;EACE,kDAAA;ACTF;;ADYA;EACE,kDAAA;ACTF;;ADYA;EACE,8CAAA;ACTF;;ADaA,YAAA;AACA;EACE,kBAxCW;EAyCX,OAAA;ACVF;;ADaA;EACE,mBA5CO;EA6CP,OAAA;ACVF;;ADaA;EACE,mBAhDM;EAiDN,OAAA;ACVF;;ADaA;EACE,eApDO;EAqDP,OAAA;ACVF;;ADaA;EACE,mBAxDO;EAyDP,OAAA;ACVF;;ADaA;EACE,kBA5DM;EA6DN,OAAA;ACVF;;AAtDA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBCqBI;EDpBJ,2BAAA;EACA,4BAAA;EACA,4DACI;EAEJ,mBAAA;EACA,qBAAA;AAuDJ;AArDI;EAEI,2BAAA;EACA,eAAA;EACA,cCpBI;AD0EZ;AAnDI;EACI,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAqDR;AAlDI;EACI,aAAA;EACA,cAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAoDR;AAjDI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,SAAA;AAmDR;AAhDI;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAkDR;AA/CI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;AAiDR;AA9CI;EACI,OAAA;AAgDR;AA5CI;EACI,WAAA;EACA,OAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AA8CR;AA3CI;EAEI,cC5EI;ED6EJ,kBAAA;EACA,YAAA;AA4CR;AAzCI;EACI,aAAA;EACA,uBAAA;EACA,WAAA;AA2CR;;AAnCI;EACI,iBAAA;AAsCR;AAnCI;EACI,2BAAA;AAqCR;AAlCI;EACI,8BAAA;AAoCR;AA5BI;EACI,aAAA;AA8BR","sourcesContent":["// FONTS\n$extraLarge: 1.75rem; // 28pt\n$large2: 1.375rem; // 22pt\n$large: 1.125rem; // 18pt\n$normal: 1rem; // 16pt\n$medium: 0.875rem; // 14pt\n$small: 0.75rem; // 12pt\n\n@font-face {\n  font-family: \"GothamBold\";\n  src: url(\"/fonts/gothambold_normal_normal.woff2\") format(\"woff2\");\n  font-weight: $normal;\n  font-style: $normal;\n}\n\n@font-face {\n  font-family: \"GothamNarrowBook\";\n  src: url(\"/fonts/GothamNarrowBook_normal_condensed.woff2\") format(\"woff2\");\n  font-weight: $normal;\n  font-style: $normal;\n}\n\n.cvx-font-gotham-bold {\n  font-family: \"GothamBold\", Arial, sans-serif;\n}\n\n.cvx-fon-narrow-bold {\n  font-family: \"GothamNarrowBold\", Arial, sans-serif;\n}\n\n.cvx-font-gotham-narrow-book {\n  font-family: \"GothamNarrowBook\", Arial, sans-serif;\n}\n\n.cvx-gothan-medium {\n  font-family: \"GothamMedium\", Arial, sans-serif;\n}\n\n\n/*font-szes*/\n.extraLarge {\n  font-size: $extraLarge;\n  /*28px*/\n}\n\n.large2 {\n  font-size: $large2;\n  /*22px*/\n}\n\n.large {\n  font-size: $large;\n  /*18px*/\n}\n\n.normal {\n  font-size: $normal;\n  /*16px*/\n}\n\n.medium {\n  font-size: $medium;\n  /*14px*/\n}\n\n.small {\n  font-size: $small;\n  /*12px*/\n}","@use '../../../../styles/fonts' as fonts;\n@use '../../../../styles/colors' as colors;\n\naside {\n    display: grid;\n    width: 100%;\n    height: 100%;\n    background-color: colors.$white;\n    grid-template-columns: 100%;\n    grid-template-rows: 40px 1fr;\n    grid-template-areas:\n        'aside-left-title'\n        'aside-left-content';\n    align-items: center;\n    justify-items: center;\n\n    .cvx-aside-left-title {\n        @extend .cvx-font-gotham-bold;\n        grid-area: aside-left-title;\n        font-size: 20px;\n        color: colors.$dark-blue;\n    }\n\n    .cvx-aside-left-content {\n        display: flex;\n        flex-direction: column;\n        grid-area: aside-left-content;\n        overflow: auto;\n        width: 100%;\n        height: 100%;\n    }\n\n    .cvx-aside-left-controls {\n        display: flex;\n        flex-shrink: 0;\n        align-items: center;\n        gap: 8px;\n        padding: 8px;\n    }\n\n    .cvx-grouping-selector {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 12px;\n        margin: 0;\n    }\n\n    .cvx-grouping-options {\n        display: flex;\n        gap: 12px;\n        align-items: center;\n        flex-wrap: wrap;\n    }\n\n    .cvx-grouping-options label {\n        display: inline-flex;\n        align-items: center;\n        gap: 4px;\n    }\n    \n    .cvx-aside-left-controls select {\n        flex: 1;\n    }\n\n\n    .cvx-tree {\n        width: 100%;\n        flex: 1;\n        overflow: auto;\n        font-size: 14px;\n        padding: 0 10px;\n    }\n\n    .cvx-tree-empty {\n        @extend .cvx-font-gotham-bold;\n        color: colors.$dark-blue;\n        text-align: center;\n        padding: 8px;\n    }\n\n    .spinner {\n        display: flex; \n        justify-content: center; \n        width: 100%;\n    }\n}\n\n// --------------------------------------------------------------------\n// Left panel --------------------------------------------\n// --------------------------------------------------------------------\n::ng-deep {\n    app-root {\n        transition: 700ms;\n    }\n\n    app-root:has(* .cvx-no-transition) {\n        transition: none !important;\n    }\n\n    app-root:has(app-cvx-aside-left aside.cvx-slide-panel.cvx-hidden-content) {\n        grid-template-columns: 0px 1fr;\n        //background-color: aqua;\n    }\n\n    // app-root {\n    //   //grid-template-columns: var(--left, 48px) auto;\n    // }\n    \n    app-root:has(app-cvx-aside-left aside.cvx-slide-panel) {\n        --left: 330px;\n        //background-color: rgb(240, 18, 184);\n    }\n}\n// --------------------------------------------------------------------\n// --------------------------------------------------------------------\n// --------------------------------------------------------------------\n\n// --------------------------------------------------------------------\n// Right pannel ----------------------------------------------\n// --------------------------------------------------------------------\n// To thest change app-cvx-aside-right POR app-cvx-aside-left\n// --------------------------------------------------------------------\n// --------------------------------------------------------------------\n// app-root {\n//   transition: 300ms;\n// }\n\n// app-root:has(app-cvx-aside-right:hover) {\n//   grid-template-columns: 30% auto;\n// }\n\n// app-root {\n//   grid-template-columns: var(--left, 48px) auto;\n// }\n\n// app-root:has(app-cvx-aside-right:hover) {\n//   --left: 30%;\n// }\n// --------------------------------------------------------------------\n// --------------------------------------------------------------------\n// --------------------------------------------------------------------\n","$dark-blue: #0b2d71;\n$medium-blue: #0066b2;\n$light-blue: #009dd9;\n$dark-teal: #003653;\n$medium-teal: #00708c;\n$light-teal: #00b2bd;\n$dark-green: #444b0d;\n$medium-green: #769231;\n$light-green: #b2cc34;\n$dark-orange: #711b00;\n$medium-orange: #e5601f;\n$light-orange: #faab18;\n$dark-red: #58001c;\n$medium-red: #97002e;\n$light-red: #e21836;\n$lighter-red: rgb(247, 235, 239);\n$dark-purple: #3a0d36;\n$medium-purple: #751269;\n$light-purple: #ba3093;\n\n$dark-gray: #6b6d6f;\n$medium-gray: #8c8f93;\n$light-gray: #dbdcdd;\n$lighter-gray: #ECECEC;\n$lightest-gray: #f7f7f7; //alternative background-gray\n$lightest-gray2: #f3f3f3;\n\n$black: #000000;\n$white: #ffffff;\n$background-gray: #ededee;\n\n$highlight-blue: #E4F4FA; // for table highlights only\n$lighter-blue: #E4ECF2;\n$primary-blue: #007bff;\n$highlight-yellow: #E3F1A2;\n$highlight-peach: #FFE594;\n$highlight-neon: #FFA4C0;\n$success: #00708c;\n$warning: #faab18;\n$error: #97002e;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
